module.exports = __webpack_public_path__ + "img/icon-plus.f83a4eca.svg";